<template>
  <div>
    <sui-grid>
      <sui-grid-column :width="16" :large-screen="2" :widescreen="2" />

      <sui-grid-column :width="16" :large-screen="14" :widescreen="14">
        <sui-form-fields :fields="2">
          <sui-form-field>
            <label>{{ $t('claim.content') }}</label>
            <InputText
              v-model="model.content"
              :disabled="disabled"
              @input="handleInput"
            />
          </sui-form-field>
          <sui-form-field>
            <label>{{ $t('claim.type') }}</label>
            <Dropdown
              v-model="model.claimType"
              :disabled="disabled"
              :options="claimTypeOptions"
              option-label="name"
              option-value="id"
              :filter="true"
              style="width: 100%"
              @input="handleInput"
            />
          </sui-form-field>
        </sui-form-fields>

        <sui-form-fields :fields="4">
          <sui-form-field v-if="model.type === ClaimType.MONETARY" >
            <span>
              <label>{{ $t('claim.effective_date') }}</label>
              <i
                v-tooltip="{ value: effectiveDateTooltipText }"
                class="sub_claim__tooltip pi pi-question-circle"
              ></i>
            </span>
            <DatePicker
              v-model="model.effectiveDate"
              :disabled="disabled"
              @input="handleInput"
            />
          </sui-form-field>
          <sui-form-field>
            <label>{{ $t('claim.date_expire') }}</label>
            <DatePicker
              v-model="model.date_expire"
              :disabled="disabled"
              @input="handleInput"
            />
          </sui-form-field>
          <sui-form-field v-if="model.type === ClaimType.PERIODICAL">
            <sui-checkbox
              v-model="model.depends_on_min_subsistence"
              :disabled="disabled"
              :label="$t('claim.dependsMinWage')"
              @input="() => handleToggle('depends_on_min_subsistence')"
            />
          </sui-form-field>

          <sui-form-field>
            <sui-checkbox
              v-model="model.mainClaim"
              :disabled="disabled"
              :label="$t('claim.basic')"
              @input="() => handleToggle('mainClaim')"
            />
          </sui-form-field>

          <!-- Technical info about claim that is useful for someone from Koda -->
          <div
            v-if="isRoleKoda()"
            class="sub-claim__claim-context"
          >
            E-Täituri ID: {{ model.tarn_id || 'puudub' }}
          </div>
        </sui-form-fields>
      </sui-grid-column>
    </sui-grid>
  </div>
</template>

<script>
import DatePicker from '../../DatePicker.vue';
import { ClaimType } from '@/static/enums/claimType';

export default {
  name: 'SubClaim',
  components: {
    DatePicker,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    claimTypeOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      effectiveDateTooltipText: 'Kui kuupäev on täidetud, ei arvestata nõuet põhitasus ega arestitavas summas kuupäeva saabumiseni.',
      ClaimType,
    }
  },
  computed: {
    model: {
      get() {
        return { ...this.data };
      },
    },
  },
  methods: {
    handleInput() {
      this.$emit('update', this.model);
    },
    handleToggle(name) {
      this.model[name] = !this.model[name];
      this.$emit('update', this.model);
    },
    isRoleKoda() {
      return this.$store.getters['user/isRoleKoda'];
    },
  },
};
</script>
<style lang="scss" scoped>
  .sub_claim__tooltip {
    margin-left: 0.25rem;
  }

  .sub-claim__claim-context {
    margin: 0 1rem 0 auto;
    color: #5a5a5a;
    font-size: 12px;
  }
</style>